import { setToken } from '@/utils/auth'

export function consumeTokenFromUrl() {
  if (typeof window === 'undefined') return false

  const url = new URL(window.location.href)
  const token = url.searchParams.get('token')
  if (!token) return false

  setToken(token)
  url.searchParams.delete('token')

  const search = url.searchParams.toString()
  const next = `${url.pathname}${search ? `?${search}` : ''}${url.hash || '#/'}`
  window.history.replaceState(null, '', next)
  return true
}